import { NavLogo } from '@atlaskit/navigation-system/top-nav-items';
import { useRouter } from 'react-resource-router';

import { RovoDevAgentsIcon } from './rovo-dev-agents-icon';
import { RovoDevAgentsLogo } from './rovo-dev-agents-logo';

export const AtlassianProductHome = () => {
	const [routeState] = useRouter();

	const Logo = routeState.route?.logo;

	if (Logo) {
		return <Logo />;
	}

	return (
		<NavLogo href="/dev-agents" logo={RovoDevAgentsLogo} icon={RovoDevAgentsIcon} label="Rovo Dev Agents" />
	);
};
